import { Component } from "react";
import BaseModal, { ModalActions, SaveButton, DeleteButton, CancelButton } from "../../../../containers/UI/Modal/BaseModal";
import InputRow from "../../../configuration/Rows/InputRow/InputRow";
import axios from "../../../../axios";

class AccountModal extends Component {

  state = {
    loading: false
  }

  resetPasswordHandler = () => {
    const { selectedAccount } = this.props;
    if (!selectedAccount) return;

    if (!window.confirm(`Send password reset email to ${selectedAccount.email}?`)) {
      return;
    }

    this.setState({ loading: true });

    axios.post(`/platforms/accounts/${selectedAccount._id}/reset-password`)
      .then((response) => {
        alert(`Password reset email has been sent to ${response.data.email || selectedAccount.email}`);
        this.props.closeModal();
      })
      .catch(err => {
        let message = "Failed to send password reset email.";
        if (err.response?.data?.message) {
          message = err.response.data.message;
        }
        alert(message);
        this.setState({ loading: false });
      });
  }

  toggle2FAHandler = () => {
    const { selectedAccount } = this.props;
    if (!selectedAccount) return;

    const has2FA = selectedAccount.twoFactorEnabled === true;
    const action = has2FA ? "disable" : "enable";

    // Show confirmation dialog
    if (!window.confirm(`Are you sure you want to ${action} 2FA for this account?${has2FA ? "\n\nThe user will be notified by email." : ""}`)) {
      return;
    }

    this.setState({ loading: true });

    axios.post(`/platforms/accounts/${selectedAccount._id}/toggle-2fa`)
      .then(() => {
        this.props.closeModal();
      })
      .catch(err => {
        let message = `Failed to ${action} 2FA.`;
        if (err.response?.data?.message) {
          message = err.response.data.message;
        }
        alert(message);
        this.setState({ loading: false });
      });
  }

  render() {
    const { selectedAccount } = this.props;
    const { loading } = this.state;
    if (!selectedAccount) return null;

    const has2FA = selectedAccount.twoFactorEnabled === true;

    return (
      <BaseModal 
        isOpen={this.props.shouldShow} 
        onClose={this.props.closeModal}
        title="Account Details"
      >
        <InputRow
          title="Name"
          firstRow
          ultrawide
          value={selectedAccount.name || ""}
          placeholder="—"
        />
        <InputRow
          title="E-mail"
          ultrawide
          value={selectedAccount.email || ""}
          placeholder="—"
        />
        <InputRow
          title="Account Number"
          ultrawide
          value={selectedAccount.accountNumber || ""}
          placeholder="—"
        />
        <InputRow
          title="Company"
          ultrawide
          value={selectedAccount.companyName || ""}
          placeholder="—"
        />

        <ModalActions>
          <CancelButton onClick={this.props.closeModal}>Close</CancelButton>
          <SaveButton onClick={this.resetPasswordHandler} disabled={loading}>Reset Password</SaveButton>
          {has2FA ? (
            <DeleteButton onClick={this.toggle2FAHandler} disabled={loading}>
              Turn off 2FA
            </DeleteButton>
          ) : (
            <SaveButton onClick={this.toggle2FAHandler} disabled={loading}>
              Turn on 2FA
            </SaveButton>
          )}
        </ModalActions>
      </BaseModal>
    );
  }
}

export default AccountModal;
